var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1536_9560)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.43381,
    y: -0.00012207,
    width: 28.8038,
    height: 30.113,
    rx: 3.92779,
    fill: "#FF8000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4292 8.67041C16.7094 8.67041 16.1476 9.05667 16.1476 9.74143C16.1476 11.8307 16.3934 14.8329 16.3934 16.9222C16.3934 17.4665 16.8675 17.6947 17.4293 17.6947C17.8506 17.6947 18.4476 17.4665 18.4476 16.9222C18.4476 14.833 18.6933 11.8307 18.6933 9.74143C18.6933 9.05673 18.114 8.67041 17.4292 8.67041ZM17.4469 18.9061C16.6744 18.9061 16.095 19.5206 16.095 20.258C16.095 20.9778 16.6744 21.6099 17.4469 21.6099C18.1667 21.6099 18.7813 20.9778 18.7813 20.258C18.7813 19.5206 18.1667 18.9061 17.4469 18.9061Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8909 8.67053C12.171 8.67053 11.6092 9.05679 11.6092 9.74155C11.6092 11.8308 11.855 14.833 11.855 16.9223C11.855 17.4666 12.3291 17.6948 12.8909 17.6948C13.3123 17.6948 13.9092 17.4666 13.9092 16.9223C13.9092 14.8331 14.155 11.8309 14.155 9.74155C14.155 9.05685 13.5756 8.67053 12.8909 8.67053ZM12.9085 18.9062C12.1361 18.9062 11.5566 19.5207 11.5566 20.2581C11.5566 20.978 12.136 21.61 12.9085 21.61C13.6284 21.61 14.2429 20.978 14.2429 20.2581C14.2429 19.5207 13.6283 18.9062 12.9085 18.9062Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3754 8.67041C21.6556 8.67041 21.0938 9.05667 21.0938 9.74143C21.0938 11.8307 21.3395 14.8329 21.3395 16.9222C21.3396 17.4665 21.8137 17.6947 22.3755 17.6947C22.7968 17.6947 23.3937 17.4665 23.3937 16.9222C23.3937 14.833 23.6395 11.8307 23.6395 9.74143C23.6395 9.05673 23.0602 8.67041 22.3754 8.67041ZM22.3931 18.9061C21.6206 18.9061 21.0411 19.5206 21.0411 20.258C21.0411 20.9778 21.6205 21.6099 22.3931 21.6099C23.1129 21.6099 23.7274 20.9778 23.7274 20.258C23.7274 19.5206 23.1128 18.9061 22.3931 18.9061Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1536_9560",
    x: 0.815283,
    y: -0.00012207,
    width: 34.0408,
    height: 35.3501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30926
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1536_9560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1536_9560",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighIcon);
export default __webpack_public_path__ + "static/media/HighIcon.bacb550d964a23f629cb30d7f4355b80.svg";
export { ForwardRef as ReactComponent };